import { ShieldAlert } from 'lucide-react';

interface AccessDeniedProps {
  message?: string;
}

const AccessDenied = ({ message }: AccessDeniedProps) => {
  return (
    <div className="text-center py-12">
      <ShieldAlert className="h-12 w-12 text-gray-400 mx-auto mb-4" />
      <h2 className="text-lg font-semibold text-gray-900">Accesso negato</h2>
      <p className="text-gray-500 mt-2">
        {message || 'Non hai i permessi necessari per accedere a questa pagina.'}
      </p>
    </div>
  );
};

export default AccessDenied;
